import React, { useEffect, useRef } from "react";
import { sharedApi } from "@/lib/api";

/**
 * Iter 631 §1 — celebratory "🎁 Gift from AllSale" banner on My coins.
 * Shown once per grant: auto-marked seen when displayed (so it hides on
 * the next open), removed immediately on "Got it 🎉".
 *   GET  /points/grants/unseen        (fetched by the parent)
 *   POST /points/grants/{id}/seen
 */
export default function GrantCelebrationBanner({ items = [], onDismiss }) {
  const marked = useRef(new Set());
  useEffect(() => {
    for (const g of items) {
      if (marked.current.has(g.id)) continue;
      marked.current.add(g.id);
      sharedApi.post(`/points/grants/${g.id}/seen`).catch(() => {});
    }
  }, [items]);
  if (!items.length) return null;
  return (
    <div className="space-y-3" data-testid="grant-banners">
      {items.map((g) => {
        const gift = g.kind === "gift";
        return (
          <div
            key={g.id}
            data-testid={`grant-banner-${g.id}`}
            className={`rounded-2xl p-4 flex gap-3 shadow-card ${
              gift
                ? "bg-gradient-to-br from-amber-200 to-amber-500"
                : "bg-gradient-to-br from-blue-200 to-blue-500"
            }`}
          >
            <div className="text-3xl leading-none mt-0.5">{gift ? "🎁" : "⭐"}</div>
            <div className="min-w-0 flex-1">
              <div className="text-[15px] font-black text-stone-900">
                {gift ? "Gift from AllSale" : "Bonus from AllSale"} · +
                {Number(g.points).toLocaleString()} pts
              </div>
              {g.message ? (
                <p className="mt-1 text-[13px] italic text-stone-800 leading-snug">
                  &ldquo;{g.message}&rdquo;
                </p>
              ) : null}
              <p className="mt-1 text-xs text-stone-700 leading-relaxed">
                Worth ${(Number(g.points) / 100).toFixed(2)} at any partner store
                {gift ? " — pay a bill with them, no review needed" : ""}
                {g.expires_at
                  ? ` · valid until ${new Date(g.expires_at).toLocaleDateString("en-NZ", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}`
                  : ""}
              </p>
              <button
                type="button"
                data-testid={`grant-banner-gotit-${g.id}`}
                onClick={() => onDismiss(g.id)}
                className="mt-2.5 rounded-full bg-white/90 hover:bg-white text-stone-900 text-[13px] font-black px-4 py-2 transition-colors"
              >
                Got it 🎉
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
